import { render, staticRenderFns } from "./rateList.vue?vue&type=template&id=73bb303e&scoped=true"
import script from "./rateList.vue?vue&type=script&lang=js"
export * from "./rateList.vue?vue&type=script&lang=js"
import style0 from "./rateList.vue?vue&type=style&index=0&id=73bb303e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bb303e",
  null
  
)

export default component.exports